import React, { useState, useEffect } from "react";

import Breadcrumb from "../Breadcrumb/Breadcrumb";
import FunctionTypeChips from "../FunctionTypeChips";

import Styled from "./SAPNavHeaderStyles";

const SAPNavHeader = ({ stacks, functionType }) => {
  const [showShadow, setShowShadow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowShadow(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Styled.Container showShadow={showShadow}>
      <Styled.Content>
        <Breadcrumb stacks={stacks} />
        <Styled.ChipsContainer>
          <FunctionTypeChips type={functionType} />
        </Styled.ChipsContainer>
      </Styled.Content>
    </Styled.Container>
  );
};

export default React.memo(SAPNavHeader);
